import { StatementInfoModel } from './StatementInfoModel';
import { StatementTypeEnum } from './StatementTypeEnum';

export class SendMailCheckRequest
{
	public StatementType: StatementTypeEnum = StatementTypeEnum.NewInformation;
	public OldRegisterNumber: string | undefined = "";
	public OldRegisterDate: string | undefined = "";
	public Email: string = "";
	public Token: string = "";
	public Comment: string | undefined = "";
	public Categories: StatementInfoModel[] = [];
	public StatementId: string | undefined = undefined;

	constructor(statementType: StatementTypeEnum, oldRegisterNumber: string | undefined, oldRegisterDate: string | undefined, email: string, token: string, comment: string | undefined, categories: StatementInfoModel[], statementId: string | undefined)
	{
		this.StatementType = statementType;
		this.OldRegisterNumber = oldRegisterNumber;
		this.OldRegisterDate = oldRegisterDate;
		this.Email = email;
		this.Token = token;
		this.Comment = comment;
		this.Categories = categories;
		this.StatementId = statementId;
	}

}
